import type { QueryStoreProps } from "./List.js";
import type { Callback, DataKey, Database } from "shelving";
import { useRef } from "react";
import { useStore } from "shelving/react";
import { useScrollIntersect } from "../util/scroll.js";

/** Button that the user can click to paginate a `QueryStore`. */
export function PaginateButton<T extends Database, K extends DataKey<T>>({
	store,
	title,
	children = `Show more ${store.collection}s`,
	mods = "",
	detect = false,
}: { title?: string | undefined; children: React.ReactNode; mods?: string | undefined } & Pick<QueryStoreProps<T, K>, "store" | "more" | "detect">): React.ReactElement | null {
	const { busy } = store;
	const loadMore = (useRef<Callback>().current ||= () => store.loadMore());
	useStore(busy);
	const ref = useScrollIntersect<HTMLButtonElement>(detect ? loadMore : undefined);
	return (
		<button //
			ref={ref}
			type="button"
			className={`button ${busy.value ? "effect-waiting" : ""} ${mods}`}
			onClick={loadMore}
			disabled={busy.value}
			title={title}
		>
			{children}
		</button>
	);
}
